/* eslint-disable consistent-return */

import { DANGER_ELEMENT_TYPE, INSTALLATION_TYPES } from 'installation/constants/InstallationConstants'
import { compact, isNil } from 'lodash'
import { getImgInstallation, getSiteUrl } from 'utils/mapUtils/SiteTypes'
import i18n from 'simple-react-i18n'
import React from 'react'
import { Icon, Tooltip } from '@mui/material'
import { GREY_BG } from 'rpqs/constants/RpqsConstant'
import { PASTEL_COLOR } from 'utils/constants/ColorTheme'
import { STATION_TYPE_CONSTANT } from 'station/constants/StationConstants'

const getUdiSectorName = (udi, sector) => {
    if (!isNil(udi)) {
        return `${udi.code} ${udi.name && `- ${udi.name}` || ''}`
    }
    return sector?.name
}

const isDanger = (answer) => answer.answerMultiChoice === 'no' || answer.answerBool

const getName = (danger) => {
    switch (danger.siteType) {
        case DANGER_ELEMENT_TYPE.INSTALLATION:
            const imgObj = getImgInstallation(danger.intValue)
            const instType = INSTALLATION_TYPES.find(it => it.code === danger.intValue) || {}
            return {
                text: `${instType?.name && `${i18n[instType.label]} - ` || ''} ${danger.name} [${danger.code || danger.siteCode}]`,
                icon: (<img className='circle' style={{ height: '30px' }} src={imgObj.url} />),
            }
        case DANGER_ELEMENT_TYPE.CONTRIBUTOR:
            return {
                icon: <Icon>business</Icon>,
                text: `${danger?.intValue && `${danger?.intValue} - ` || ''} ${danger.name} [${danger.siret || danger.code}]`,
            }
        case DANGER_ELEMENT_TYPE.SECTOR:
            return {
                icon: <Icon className='right blue-text clickable map-right-icon'>map</Icon>,
                text: `${danger.name} [${danger.siteCode}]`,
            }
        default:
            return {
                text: danger.name,
                icon: <Icon>cancel</Icon>,
            }
    }
}

const getBgColor = (value) => {
    if (value <= 50) return PASTEL_COLOR.green
    if (value <= 100) return PASTEL_COLOR.orange
    if (value <= 200) return PASTEL_COLOR.red

    return GREY_BG
}

const getElementName = (list, id) => {
    const element = list[id] || {}
    return (element?.name || '') + (element?.code ? ` [${element.code}]` : '')
}

const getIcon = (danger, contributors, installations, size = '1rem') => {
    if (danger.siteType === STATION_TYPE_CONSTANT.CONTRIBUTOR) {
        return (
            <Tooltip title={getElementName(contributors, danger.siteCode)}>
                <img style={{ width: size }} src={getSiteUrl('CONTRIBUTOR')} />
            </Tooltip>
        )
    } else if (danger.siteType === STATION_TYPE_CONSTANT.INSTALLATION) {
        const instType = INSTALLATION_TYPES.find(it => it.code === installations[danger.siteCode]?.installationType) || {}
        return (
            <Tooltip title={getElementName(installations, danger.siteCode)}>
                <img style={{ width: size }} src={getSiteUrl(instType.img)} />
            </Tooltip>
        )
    }
    return undefined
}

const getTitle = (danger, contributors, installations, installationsTypes) => {
    if (isNil(danger.siteType)) {
        return i18n.allStructureElements
    }
    const list = danger.siteType !== STATION_TYPE_CONSTANT.INSTALLATION ? contributors : installations
    const { code, name, installationType } = list[danger.siteCode] || {}
    const typeName = installationsTypes.find(it => it.code === installationType)?.name

    return compact([code && `[${code}]`, name, typeName && `- ${typeName}`]).join(' ')
}

const getDeleteOption = (user, cb) => (user.isAdmin === '1' || user.metadata === '1') ? { delete: cb } : {}

export {
    getUdiSectorName,
    isDanger,
    getName,
    getBgColor,
    getElementName,
    getIcon,
    getTitle,
    getDeleteOption,
}
